import { Modal, ModalBody, ModalFoot, ModalHead } from '@dixa/lib-shared-habla';

import { createAppModal } from 'utils/modal';

import styles from './emailHeadersModal.module.scss';

export const EmailHeadersModal = createAppModal(
  {
    type: 'conversation:emailHeaders',
  },

  ({
    isOpen,
    modal: {
      arg: { emailHeaders },
    },
    hide,
  }): JSX.Element => {
    const formatEmailHeaders = (headers: string): string => {
      try {
        const parsed = JSON.parse(headers);
        return JSON.stringify(parsed, null, 2);
      } catch {
        return headers;
      }
    };

    return (
      <Modal
        className={styles.emailHeadersModal}
        isOpen={isOpen}
        onClose={hide}
        allowClickOutside
        allowEscClose
      >
        <ModalHead title="Email headers" onClose={hide} />
        <ModalBody>
          <pre className={styles.headersView}>
            {formatEmailHeaders(emailHeaders)}
          </pre>
        </ModalBody>
        <ModalFoot
          cancelOnClick={hide}
          cancelName="Close"
          cancelProps={{ variant: 'primary' }}
        />
      </Modal>
    );
  },
);
